import React from "react";
import { Box } from "@mui/material";
import IconComponent from "../../../components/Icon/IconComponent";
import TypographyInline from "../../../components/Typography/TypographyInline";
import CustomTooltip from "../../../components/Tooltip/CustomTooltip";
import { BRAND, BORDER, GREY, SUCCESS } from "../../../utils/constants/colors";
import { fontWeight, ICON_LABELS } from "../../../utils/constants/UI";

const formatStartDate = (epochMs) => {
  if (!epochMs) return "";
  try {
    return new Date(epochMs).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  } catch {
    return "";
  }
};

const tzShortLabel = (tz) =>
  tz?.split("/").pop()?.replace(/_/g, " ") || tz || "";

const TimezoneChip = ({ timezone, scheduledDate }) => {
  if (!timezone) return null;

  const cityLabel = tzShortLabel(timezone);
  const dateLabel = formatStartDate(scheduledDate);
  const fullText = dateLabel
    ? `${cityLabel} · Starts ${dateLabel}`
    : cityLabel;
  const tooltipText = scheduledDate
    ? `${timezone} · Starts ${new Date(scheduledDate).toLocaleDateString(
        "en-US",
        { weekday: "short", month: "short", day: "numeric", year: "numeric" },
      )}`
    : timezone;

  return (
    <CustomTooltip title={tooltipText}>
      <Box sx={styles.chip}>
        <IconComponent
          iconLabel={ICON_LABELS.LANGUAGE}
          color={BRAND.PRIMARY}
          fontSize="13px"
        />
        <Box component="span" sx={styles.label}>
          {fullText}
        </Box>
      </Box>
    </CustomTooltip>
  );
};

const styles = {
  chip: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "0 10px",
    borderRadius: "14px",
    background: "#FFFFFF",
    border: `1px solid ${BORDER.DEFAULT}`,
    height: "28px",
    cursor: "default",
    userSelect: "none",
    whiteSpace: "nowrap",
    flexShrink: 0,
    fontSize: "12px",
    color: GREY.SECONDARY,
    fontWeight: fontWeight.MEDIUM,
    lineHeight: 1,
  },
  label: {
    whiteSpace: "nowrap",
  },
};

export default TimezoneChip;
